import { sendInteractionBeforeLogout } from './interactionHelper';

let expiryTimer = null;

export const startTokenExpiryTimer = () => {
  const tokenExpiry = JSON.parse(localStorage.getItem('tokenExpiry'));

  if (!tokenExpiry) {
    return;
  }

  const { generatedAt, expiresIn } = tokenExpiry;

  if (!generatedAt || !expiresIn) {
    return;
  }

  if (expiryTimer) {
    clearTimeout(expiryTimer);
  }

  const expiryTime = new Date(generatedAt).getTime() + expiresIn * 1000;

  const remainingTime = expiryTime - Date.now() - 30000;
  if (remainingTime <= 0) {
    sendInteractionBeforeLogout();
    return;
  }

  expiryTimer = setTimeout(async () => {
    try {
      await sendInteractionBeforeLogout();
      console.log('Interaction saved before token expiry');
    } catch (e) {
      console.error(e);
    }
  }, remainingTime);
};

export const clearTokenExpiryTimer = () => {
  if (expiryTimer) {
    clearTimeout(expiryTimer);
  }
};
